import classes from "./RecipeBody.module.css";

import { useCocktails } from "../../../store/CocktailContext"

import DrinkIngredients from "../DrinkIngredients/DrinkIngredients";
import DrinkRecipe from "../DrinkRecipe/DrinkRecipe";


// component contains body of recipe card
// conditionally display garnish if recipe has garnish
const RecipeBody = (props) => {
  const { loadedImages } = useCocktails();
  const cocktail = props.drink;

  return (
    <div className={classes.recipe_body}>
      <div className={classes.image_blocker} style={{borderImageSource:`url(${process.env.PUBLIC_URL}/assets/borders/border_2.png)`}}>
        <img src={loadedImages[cocktail.image]?.src} className={classes.drink_image}  alt="new" />

      </div>
      <DrinkIngredients
        title="Ingredients"
        ingredients={cocktail.ingredients}
      />
      {cocktail.garnish.length > 0 && (
        <DrinkIngredients title="Garnish" ingredients={cocktail.garnish} />
      )}

      <DrinkRecipe recipe={cocktail.recipe} />
    </div>
  );
};

export default RecipeBody;
